export default __webpack_public_path__ + "static/media/PrintWHT.9f2ea9b3.svg";